(function () {
  function slugify(text) {
    return String(text || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildTableOfContents() {
    var content = document.querySelector('[data-hirakan-article-body]');
    var toc = document.querySelector('[data-hirakan-toc]');
    var list = document.querySelector('[data-hirakan-toc-list]');
    if (!content || !toc || !list) return;

    var usedIds = {};
    list.innerHTML = '';
    var headings = Array.from(content.querySelectorAll('h2, h3'));
    headings.forEach(function (heading) {
      var baseId = slugify(heading.textContent) || 'section';
      usedIds[baseId] = (usedIds[baseId] || 0) + 1;
      var id = usedIds[baseId] === 1 ? baseId : baseId + '-' + usedIds[baseId];
      heading.id = heading.id || id;

      var item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    var firstHeading = content.querySelector('h2, h3');
    if (firstHeading) {
      firstHeading.parentNode.insertBefore(toc, firstHeading);
    } else {
      content.insertBefore(toc, content.firstChild);
    }

    if (headings.length) toc.hidden = false;
  }

  function wrapResponsiveTables() {
    var content = document.querySelector('[data-hirakan-article-body]');
    if (!content) return;

    function nearestHeading(table, index) {
      var headings = Array.from(content.querySelectorAll('h2, h3'));
      var previous = headings.filter(function (heading) {
        return (heading.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
      }).pop();
      return previous ? previous.textContent.trim() : 'Kanji table ' + (index + 1);
    }

    function enhanceTable(table, index) {
      var wrapper = table.parentElement && table.parentElement.classList.contains('hirakan-table-scroll')
        ? table.parentElement
        : null;
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'hirakan-table-scroll';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }

      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', nearestHeading(table, index) + ' table');
      wrapper.setAttribute('tabindex', '0');

      var hint = wrapper.previousElementSibling;
      if (!hint || !hint.classList.contains('hirakan-table-scroll__hint')) {
        hint = document.createElement('p');
        hint.className = 'hirakan-table-scroll__hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = 'Swipe sideways to see all columns →';
        wrapper.parentNode.insertBefore(hint, wrapper);
      }

      function updateHint() {
        var hasOverflow = wrapper.scrollWidth > wrapper.clientWidth + 1;
        hint.hidden = !hasOverflow || wrapper.scrollLeft > 4;
      }

      function createStickyHeader() {
        if (!table.tHead || wrapper.previousElementSibling?.classList.contains('hirakan-table-sticky-header')) return;
        var sticky = document.createElement('div');
        sticky.className = 'hirakan-table-sticky-header';
        sticky.setAttribute('aria-hidden', 'true');
        var stickyTable = document.createElement('table');
        stickyTable.innerHTML = table.tHead.outerHTML;
        sticky.appendChild(stickyTable);
        var stickyFirst = document.createElement('div');
        stickyFirst.className = 'hirakan-table-sticky-header__first';
        var stickyFirstTable = document.createElement('table');
        stickyFirstTable.innerHTML = '<thead><tr></tr></thead>';
        stickyFirstTable.querySelector('tr').appendChild(table.tHead.rows[0].cells[0].cloneNode(true));
        stickyFirst.appendChild(stickyFirstTable);
        sticky.appendChild(stickyFirst);
        wrapper.parentNode.insertBefore(sticky, wrapper);

        function syncStickyHeader() {
          var wrapperRect = wrapper.getBoundingClientRect();
          var tableRect = table.getBoundingClientRect();
          var header = table.tHead;
          var headerRect = header.getBoundingClientRect();
          var top = 0;
          var active = headerRect.top < top && tableRect.bottom > top + headerRect.height;
          sticky.style.display = active ? 'block' : 'none';
          if (!active) return;
          sticky.style.left = wrapperRect.left + 'px';
          sticky.style.top = top + 'px';
          sticky.style.width = wrapperRect.width + 'px';
          stickyTable.style.width = tableRect.width + 'px';
          stickyTable.style.transform = 'translateX(' + (-wrapper.scrollLeft) + 'px)';
          var originalFirstCell = header.rows[0]?.cells[0];
          if (originalFirstCell) {
            stickyFirst.style.width = originalFirstCell.getBoundingClientRect().width + 'px';
            stickyFirst.style.height = headerRect.height + 'px';
            stickyFirstTable.style.width = originalFirstCell.getBoundingClientRect().width + 'px';
            stickyFirstTable.style.height = headerRect.height + 'px';
          }
          Array.from(stickyTable.querySelectorAll('thead th')).forEach(function (cell, cellIndex) {
            var originalCell = header.rows[0]?.cells[cellIndex];
            if (originalCell) cell.style.width = originalCell.getBoundingClientRect().width + 'px';
          });
        }

        wrapper.addEventListener('scroll', syncStickyHeader, { passive: true });
        window.addEventListener('scroll', syncStickyHeader, { passive: true });
        window.addEventListener('resize', syncStickyHeader);
        syncStickyHeader();
      }

      wrapper.addEventListener('scroll', updateHint, { passive: true });
      window.addEventListener('resize', updateHint);
      updateHint();
      createStickyHeader();
    }

    Array.from(content.querySelectorAll('table')).forEach(function (table, index) {
      enhanceTable(table, index);
    });
  }

  function moveInlineProductCards() {
    var content = document.querySelector('[data-hirakan-article-body]');
    var productGroup = document.querySelector('[data-hirakan-widget="product-inserts"]');
    if (!content || !productGroup) return;

    var cards = Array.from(productGroup.querySelectorAll('[data-hirakan-widget="product-insert"]'));
    cards.forEach(function (card) {
      var slotId = card.getAttribute('data-product-slot-id');
      if (!slotId) return;
      var slots = Array.from(content.querySelectorAll('[data-hirakan-product-slot]')).filter(function (slot) {
        return slot.getAttribute('data-hirakan-product-slot') === slotId;
      });
      if (slots.length !== 1) {
        console.warn('Hirakan product card was not placed because its slot is missing or duplicated:', slotId);
        return;
      }
      slots[0].replaceWith(card);
    });

    if (!productGroup.querySelector('[data-hirakan-widget="product-insert"]')) productGroup.remove();
  }

  function moveInlineProductGrids() {
    var content = document.querySelector('[data-hirakan-article-body]');
    var gridGroup = document.querySelector('[data-hirakan-widget="product-grids"]');
    if (!content || !gridGroup) return;

    var grids = Array.from(gridGroup.querySelectorAll('[data-hirakan-widget="product-grid"]'));
    grids.forEach(function (grid) {
      var slotId = grid.getAttribute('data-product-grid-slot-id');
      if (!slotId) return;
      var slots = Array.from(content.querySelectorAll('[data-hirakan-product-grid-slot]')).filter(function (slot) {
        return slot.getAttribute('data-hirakan-product-grid-slot') === slotId;
      });
      if (slots.length === 0) {
        var fallbackSlot = document.getElementById(slotId);
        if (fallbackSlot && content.contains(fallbackSlot)) slots = [fallbackSlot];
      }
      if (slots.length !== 1) {
        console.warn('Hirakan product grid was not placed because its slot is missing or duplicated:', slotId);
        return;
      }
      slots[0].replaceWith(grid);
    });

    if (!gridGroup.querySelector('[data-hirakan-widget="product-grid"]')) gridGroup.remove();
  }

  function trackEvent(name, parameters) {
    var payload = Object.assign({
      source_page_path: window.location.pathname,
    }, parameters || {});
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  function initEndActionForms() {
    var forms = Array.from(document.querySelectorAll('[data-hirakan-email-form]'));
    forms.forEach(function (form) {
      var section = form.closest('[data-hirakan-end-actions]');
      var offer = form.closest('[data-hirakan-email-offer]');
      var button = form.querySelector('[data-hirakan-email-submit]');
      var message = form.querySelector('[data-hirakan-email-message]');
      var iframe = offer ? offer.querySelector('[data-hirakan-email-frame]') : null;
      if (!section || !offer || !button || !message || !iframe) return;

      var baseParameters = {
        offer_id: form.getAttribute('data-offer-id') || '',
        placement: form.getAttribute('data-placement') || 'end_actions',
        copy_variant: form.getAttribute('data-copy-variant') || '',
        article_revision_id: section.getAttribute('data-article-revision-id') || '',
      };
      var viewTracked = false;
      var submitting = false;

      function trackView() {
        if (viewTracked) return;
        viewTracked = true;
        trackEvent('blog_email_form_view', baseParameters);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) {
            trackView();
            observer.disconnect();
          }
        }, { threshold: [0.5] });
        observer.observe(offer);
      } else {
        trackView();
      }

      var submitted = false;
      var fallbackTimer = null;

      function finishSubmission(success, errorType) {
        if (!submitted) return;
        submitted = false;
        window.clearTimeout(fallbackTimer);
        submitting = false;
        button.disabled = false;
        button.textContent = 'Send me the chart';
        if (success) {
          form.reset();
          message.textContent = 'Check your inbox. The printable chart should arrive in a moment.';
          message.classList.remove('is-error');
          trackEvent('blog_email_form_submit', Object.assign({}, baseParameters, { submission_result: 'success' }));
        } else {
          message.textContent = errorType === 'timeout'
            ? 'This is taking longer than expected. Please try again.'
            : 'Sorry, something went wrong. Please try again.';
          message.classList.add('is-error');
          trackEvent('blog_email_form_error', Object.assign({}, baseParameters, { error_type: errorType || 'unconfirmed' }));
        }
      }

      form.addEventListener('submit', function (event) {
        if (submitting) {
          event.preventDefault();
          return;
        }

        submitting = true;
        submitted = true;
        button.disabled = true;
        button.textContent = 'Sending...';
        message.textContent = '';
        message.classList.remove('is-error');
        window.clearTimeout(fallbackTimer);
        fallbackTimer = window.setTimeout(function () {
          finishSubmission(false, 'timeout');
        }, 15000);
      });

      iframe.addEventListener('load', function () {
        if (!submitted) return;

        var responseUrl = '';
        var responseBody = '';
        try {
          responseUrl = iframe.contentWindow.location.href || '';
          responseBody = iframe.contentDocument?.body?.innerText || '';
        } catch (error) {
          finishSubmission(false, 'unconfirmed');
          return;
        }

        var explicitError = /(form__message--error|there was a problem|please enter a valid|captcha|challenge)/i.test(responseUrl + ' ' + responseBody);
        finishSubmission(!explicitError, explicitError ? 'explicit_response_error' : '');
      });
    });
  }

  function initEndActions() {
    initEndActionForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wrapResponsiveTables();
      buildTableOfContents();
      moveInlineProductCards();
      moveInlineProductGrids();
      initEndActions();
    });
  } else {
    wrapResponsiveTables();
    buildTableOfContents();
    moveInlineProductCards();
    moveInlineProductGrids();
    initEndActions();
  }
})();
